export const LINK_COLUMN = 'link-column';
